import { rankWith, uiTypeIs, LayoutProps } from '@jsonforms/core';
import {
  ResolvedJsonFormsDispatch,
  withJsonFormsLayoutProps,
} from '@jsonforms/react';
import { getElements } from '../../../../../utils/DynamicForms';

type Props = LayoutProps; // use correct prop type

const TabLayout = (props: Props) => {
  if (!props.visible) return null;
  return (
    <div className="tru-layout-tab tru-dynamic-form-wrapper">
      {getElements(props.uischema).map((element, index) => (
        <ResolvedJsonFormsDispatch {...props} uischema={element} key={index} />
      ))}
    </div>
  );
};

export const TabLayoutEntry = {
  tester: rankWith(1, uiTypeIs('Tab')),
  renderer: withJsonFormsLayoutProps(TabLayout),
};
